import type { ComponentOptionsWithObjectProps } from 'vue'
import type { ModalProps, TailvueModal } from '~/types'
import GlobalModal from '~/components/GlobalModal.vue'

function spawn(id: string, props: ModalProps, Component: ComponentOptionsWithObjectProps, classes?: string[]) {
  const el = document.createElement('div')
  if (classes) {
    classes.forEach((c) => {
      if (el && el.classList)
        el.classList.add(c)
    })
  }
  return createApp(
    defineComponent(Component),
    props as unknown as Record<string, unknown>,
  ).mount(document?.getElementById(id)?.appendChild(el) as Element)
}

export function useModal(): TailvueModal {
  const modals = document.createElement('div')
  modals.classList.add('z-60')
  modals.setAttribute('id', 'modals')
  document.body.appendChild(modals)
  return {
    show(props: ModalProps | string) {
      if (typeof props === 'string')
        props = { title: props }
      return spawn('modals', props, GlobalModal as unknown as ComponentOptionsWithObjectProps)
    },
  }
}
